import * as React from "react";
const SvgStepsInProgress = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, strokeDasharray: "2 2" }));
export default SvgStepsInProgress;
